var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/useApi/useApi.ts
import { localApiDelete, localApiFetch, localApiGet, localApiPatch, localApiPost, localApiPut } from "@websolutespa/bom-mixer-store";

// src/useHttp/useHttp.ts
import { httpFetch } from "@websolutespa/bom-core";
import { useEffect, useState } from "react";
function useHttpFetch(pathname, options = { method: "GET" }, service = httpFetch, serviceOptions) {
  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = () => __async(this, null, function* () {
      loading ? null : setLoading(true);
      error ? setError(null) : null;
      try {
        const response2 = yield service(pathname, options, serviceOptions);
        setResponse(response2);
      } catch (error2) {
        setError(error2);
      }
      setLoading(false);
    });
    fetchData();
  }, [pathname, options.method, options.body]);
  return [response, loading, error, setError];
}

// src/useGenericContext/useGenericContext.ts
import { createContext, useContext } from "react";
var createGenericContext = (defaultContext = null) => {
  const genericContext = createContext(defaultContext);
  const useGenericContext = () => {
    const context = useContext(genericContext);
    if (!context) {
      throw new Error("useGenericContext must be used within a Provider");
    }
    return context;
  };
  return [useGenericContext, genericContext.Provider, genericContext];
};

// src/useLayout/useLayout.tsx
import { jsx } from "react/jsx-runtime";
var [useLayout, LayoutContextProvider] = createGenericContext();
function LayoutProvider({ children, layout }) {
  return /* @__PURE__ */ jsx(LayoutContextProvider, { value: layout, children });
}

// src/useApi/useApi.ts
function useApiFetch(pathname, options = {}) {
  const layout = useLayout();
  return useHttpFetch(pathname, options, localApiFetch, layout);
}
function useApiGet(pathname, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "GET" }));
}
function useApiPost(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "POST", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useApiPut(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "PUT", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useApiPatch(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "PATCH", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useApiDelete(pathname, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "DELETE" }));
}
function useApi() {
  const layout = useLayout();
  return {
    get: (_0, ..._1) => __async(this, [_0, ..._1], function* (pathname, options = {}) {
      return localApiGet(pathname, options, layout);
    }),
    post: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localApiPost(pathname, payload, options, layout);
    }),
    put: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localApiPut(pathname, payload, options, layout);
    }),
    patch: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localApiPatch(pathname, payload, options, layout);
    }),
    delete: (_0, ..._1) => __async(this, [_0, ..._1], function* (pathname, options = {}) {
      return localApiDelete(pathname, options, layout);
    })
  };
}

// src/useAutosizeTextArea/useAutosizeTextArea.ts
import { useEffect as useEffect2 } from "react";
function useAutosizeTextArea(textAreaRef, value) {
  useEffect2(() => {
    if (textAreaRef) {
      textAreaRef.style.minHeight = "0px";
      textAreaRef.style.minHeight = textAreaRef.scrollHeight + "px";
    }
  }, [textAreaRef, value]);
}

// src/useBodyScroll/useBodyScroll.ts
import { useEffect as useEffect3, useRef, useState as useState2 } from "react";
var defaultOptions = {
  scrollLayer: false,
  delayReset: 0
};
var elementStack = /* @__PURE__ */ new Map();
function useBodyScroll(elementRef, options) {
  if (typeof document === "undefined") {
    return [false, (t) => t];
  }
  elementRef = elementRef || useRef(document.body);
  const [hidden, setHidden] = useState2(false);
  const safeOptions = __spreadValues(__spreadValues({}, defaultOptions), options || {});
  useEffect3(() => {
    if (!elementRef || !elementRef.current) {
      return;
    }
    const lastOverflow = elementRef.current.style.overflow;
    if (hidden) {
      if (elementStack.has(elementRef.current)) {
        return;
      }
      const paddingRight = getOwnerPaddingRight(elementRef.current);
      const scrollbarWidth = getOwnerScrollbarWidth(elementRef.current);
      elementStack.set(elementRef.current, {
        overflow: lastOverflow,
        paddingRight: elementRef.current.style.paddingRight
      });
      elementRef.current.style.setProperty("--locked-padding-right", `${paddingRight + scrollbarWidth}px`);
      elementRef.current.style.overflow = "hidden";
      elementRef.current.style.paddingRight = "var(--locked-padding-right)";
      return;
    }
    if (!elementStack.has(elementRef.current)) {
      return;
    }
    const reset = (element) => {
      const store = elementStack.get(element);
      if (!store) {
        return;
      }
      element.style.setProperty("--locked-padding-right", "0");
      element.style.overflow = store.overflow;
      element.style.paddingRight = store.paddingRight;
      elementStack.delete(element);
    };
    const timer = window.setTimeout(() => {
      reset(elementRef.current);
      window.clearTimeout(timer);
    }, safeOptions.delayReset);
  }, [hidden, elementRef]);
  return [hidden, setHidden];
}
function getOwnerPaddingRight(element) {
  const owner = (element == null ? void 0 : element.ownerDocument) || document;
  const view = owner.defaultView || window;
  return Number.parseInt(view.getComputedStyle(element).paddingRight, 10) || 0;
}
function getOwnerScrollbarWidth(element) {
  const doc = (element == null ? void 0 : element.ownerDocument) || document;
  return Math.abs(window.innerWidth - doc.documentElement.clientWidth);
}

// src/useBreakpoint/useBreakpoint.ts
import { useContext as useContext2, useMemo } from "react";
import { ThemeContext } from "styled-components";

// src/useWindowSize/useWindowSize.ts
import { useState as useState3 } from "react";

// src/useEventListener/useEventListener.ts
import { useEffect as useEffect5, useRef as useRef2 } from "react";

// src/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.ts
import { isBrowser } from "@websolutespa/bom-core";
import { useEffect as useEffect4, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect4;

// src/useEventListener/useEventListener.ts
function useEventListener_(eventName, handler, element, options) {
  const savedHandler = useRef2(handler);
  useIsomorphicLayoutEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect5(() => {
    const targetElement = (element == null ? void 0 : element.current) || window;
    if (!(targetElement && targetElement.addEventListener)) {
      return;
    }
    const eventListener = (event) => savedHandler.current(event);
    targetElement.addEventListener(eventName, eventListener, options);
    return () => {
      targetElement.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, options]);
}
var useEventListener = useEventListener_;

// src/useWindowSize/useWindowSize.ts
function useWindowSize() {
  const [windowSize, setWindowSize] = useState3({
    width: 0,
    height: 0
  });
  const handleSize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setWindowSize({ width, height });
  };
  useEventListener("resize", handleSize);
  useIsomorphicLayoutEffect(() => {
    handleSize();
  }, []);
  return windowSize;
}

// src/useBreakpoint/useBreakpoint.ts
function useBreakpoint(mediaQuery) {
  const windowSize = useWindowSize();
  const theme = useContext2(ThemeContext);
  if (!theme && !mediaQuery) {
    throw new Error("useBreakpoint must be used within ThemeProvider");
  }
  const queries = mediaQuery || theme.mediaQuery;
  const breakpoints = Object.keys(queries);
  const values = Object.values(queries).map((x) => parseInt(String(x)));
  const breakpoint = useMemo(() => {
    const breakpoint2 = values.reduce((p, c, i) => {
      if (c < windowSize.width) {
        p.key = breakpoints[i];
        p.min = c;
        if (i + 1 < values.length) {
          p.max = values[i + 1];
        } else {
          p.max = Number.POSITIVE_INFINITY;
        }
      }
      return p;
    }, { key: "xs", min: -Number.NEGATIVE_INFINITY, max: -Number.NEGATIVE_INFINITY });
    return breakpoint2;
  }, [windowSize.width]);
  return breakpoint;
}

// src/useClickAnyWhere/useClickAnyWhere.ts
import { useEffect as useEffect6 } from "react";
function useClickAnyWhere(handler) {
  useEffect6(() => {
    const callback = (event) => handler(event);
    document.addEventListener("click", callback);
    return () => document.removeEventListener("click", callback);
  }, [handler]);
}

// src/useClickOut/useClickOut.ts
import { useEffect as useEffect7, useRef as useRef3 } from "react";
function useClickOut(ref, handler) {
  const handlerRef = useRef3(handler);
  useEffect7(() => {
    handlerRef.current = handler;
  }, [handler]);
  useEffect7(() => {
    const callback = (event) => {
      const el = ref.current;
      if (!event || !el || el.contains(event.target)) {
        return;
      }
      handlerRef.current(event);
    };
    document.addEventListener("click", callback);
    return () => document.removeEventListener("click", callback);
  }, [ref]);
}

// src/useCollectionApi/local.collection.ts
import { httpFetch as httpFetch2, merge } from "@websolutespa/bom-core";
import { getLocalApiRequestOptions, getLocalApiUrl } from "@websolutespa/bom-mixer-store";
function localCollectionFetch(_0) {
  return __async(this, arguments, function* (pathname, options = {}, serviceOptions) {
    const url = new URL(getLocalApiUrl(pathname));
    if (serviceOptions) {
      url.searchParams.append("locale", serviceOptions.locale);
      url.searchParams.append("market", serviceOptions.market);
    }
    const apiOptions = merge(__spreadValues({}, getLocalApiRequestOptions()), options);
    const apiResponse = yield httpFetch2(url.href, apiOptions);
    return apiResponse;
  });
}
function localCollectionGet(_0) {
  return __async(this, arguments, function* (url, options = {}, serviceOptions) {
    return yield localCollectionFetch(url, __spreadProps(__spreadValues({}, options), { method: "GET" }), serviceOptions);
  });
}
function localCollectionPost(_0, _1) {
  return __async(this, arguments, function* (url, payload, options = {}, serviceOptions) {
    return yield localCollectionFetch(url, __spreadProps(__spreadValues({}, options), { method: "POST", body: payload ? JSON.stringify(payload) : void 0 }), serviceOptions);
  });
}
function localCollectionPut(_0, _1) {
  return __async(this, arguments, function* (url, payload, options = {}, serviceOptions) {
    return yield localCollectionFetch(url, __spreadProps(__spreadValues({}, options), { method: "PUT", body: payload ? JSON.stringify(payload) : void 0 }), serviceOptions);
  });
}
function localCollectionPatch(_0, _1) {
  return __async(this, arguments, function* (url, payload, options = {}, serviceOptions) {
    return yield localCollectionFetch(url, __spreadProps(__spreadValues({}, options), { method: "PATCH", body: payload ? JSON.stringify(payload) : void 0 }), serviceOptions);
  });
}
function localCollectionDelete(_0) {
  return __async(this, arguments, function* (url, options = {}, serviceOptions) {
    return yield localCollectionFetch(url, __spreadProps(__spreadValues({}, options), { method: "DELETE" }), serviceOptions);
  });
}

// src/useCollectionApi/useCollectionApi.ts
import { qsSerialize } from "@websolutespa/bom-core";
function useCollectionApi() {
  const layout = useLayout();
  return {
    get: (_0, ..._1) => __async(this, [_0, ..._1], function* (pathname, params = {}, options = {}) {
      params.locale = params.locale || layout.locale;
      params.market = params.market || layout.market;
      const qs = qsSerialize(params);
      return localCollectionGet(pathname + (qs ? "?" + qs : ""), options);
    }),
    post: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localCollectionPost(pathname, payload, options, layout);
    }),
    put: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localCollectionPut(pathname, payload, options, layout);
    }),
    patch: (_0, _1, ..._2) => __async(this, [_0, _1, ..._2], function* (pathname, payload, options = {}) {
      return localCollectionPatch(pathname, payload, options, layout);
    }),
    delete: (_0, ..._1) => __async(this, [_0, ..._1], function* (pathname, options = {}) {
      return localCollectionDelete(pathname, options, layout);
    })
  };
}
function useCollectionApiGet(pathname, params, options = {}) {
  const api = useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "GET" }));
  return api;
}
function useCollectionApiPost(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "POST", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useCollectionApiPut(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "PUT", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useCollectionApiPatch(pathname, payload, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "PATCH", body: payload ? JSON.stringify(payload) : void 0 }));
}
function useCollectionApiDelete(pathname, options = {}) {
  return useApiFetch(pathname, __spreadProps(__spreadValues({}, options), { method: "DELETE" }));
}

// src/useColorScheme/useColorScheme.ts
import { isBrowser as isBrowser2 } from "@websolutespa/bom-core";
import { createStore, useStore } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
var QUERY = "(prefers-color-scheme: dark)";
function getPreferredColorScheme() {
  return isBrowser2 && window.matchMedia(QUERY).matches ? "dark" : "light";
}
var updateClassList = (colorScheme) => {
  if (isBrowser2) {
    document.documentElement.classList.add("--force-reduced-motion");
    document.documentElement.classList.toggle("--scheme-dark", colorScheme === "dark");
    document.documentElement.classList.toggle("--scheme-light", colorScheme === "light");
    requestAnimationFrame(() => {
      document.documentElement.classList.remove("--force-reduced-motion");
    });
  }
};
var createColorSchemeStore = (_a) => {
  var _b = _a, {
    name,
    storage
  } = _b, initialState = __objRest(_b, [
    "name",
    "storage"
  ]);
  const defaultState = {
    colorScheme: "light"
  };
  const useStore3 = createStore()(persist(
    (set, get) => __spreadProps(__spreadValues(__spreadValues({}, defaultState), initialState), {
      actions: {
        setColorScheme: (colorScheme) => {
          updateClassList(colorScheme);
          set((state) => ({ colorScheme }));
        },
        toggleColorScheme: () => {
          const state = get();
          const newColorScheme = state.colorScheme === "light" ? "dark" : "light";
          updateClassList(newColorScheme);
          set((state2) => ({ colorScheme: newColorScheme }));
        }
      }
    }),
    {
      name,
      storage: createJSONStorage(() => storage || sessionStorage),
      merge: (persistedState, currentState) => {
        const newColorScheme = (persistedState == null ? void 0 : persistedState.colorScheme) || getPreferredColorScheme();
        updateClassList(newColorScheme);
        currentState.colorScheme = newColorScheme;
        return currentState;
      }
      // getStorage: () => {
      //  return storage || sessionStorage;
      // },
      // onRehydrateStorage: () => () => {
      //  console.log('onRehydrateStorage', useStore, useStore.getState());
      // },
    }
  ));
  return useStore3;
};
var colorSchemeSingletonStore_;
var createColorSchemeSingletonStore = () => {
  colorSchemeSingletonStore_ = colorSchemeSingletonStore_ || createColorSchemeStore({ name: "prefers-color-scheme" });
  return colorSchemeSingletonStore_;
};
function useColorScheme(selector) {
  return useStore(createColorSchemeSingletonStore(), selector);
}

// src/useNumber/useNumber.ts
import { useMemo as useMemo2 } from "react";
function useNumber(options, locale) {
  const layout = useLayout();
  const currentLocale = locale || layout.locale;
  const flatOptions = options ? Object.entries(options).map(([k, v]) => `${k}:${v}`).join("") : void 0;
  const formatter = useMemo2(() => {
    const formatter2 = new Intl.NumberFormat(currentLocale, options).format;
    return formatter2;
  }, [currentLocale, flatOptions]);
  return formatter;
}

// src/useCurrency/useCurrency.ts
function useCurrency(currency = "EUR", locale) {
  return useNumber({ style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }, locale);
}

// src/useCurrentState/useCurrentState.ts
import { useEffect as useEffect8, useRef as useRef4, useState as useState4 } from "react";
function useCurrentState(initialState) {
  const [state, setState] = useState4(() => {
    return typeof initialState === "function" ? initialState() : initialState;
  });
  const ref = useRef4(initialState);
  useEffect8(() => {
    ref.current = state;
  }, [state]);
  const setValue = (val) => {
    const result = typeof val === "function" ? val(ref.current) : val;
    ref.current = result;
    setState(result);
  };
  return [state, setValue, ref];
}

// src/useDateTimeFormat/useDateTimeFormat.ts
function useDateTimeFormat(options = {
  // weekday: 'long',
  year: "numeric",
  month: "numeric",
  day: "numeric"
}, locale) {
  const layout = useLayout();
  const dateTimeFormat = (value) => {
    const date = value instanceof Date ? value : new Date(value);
    const formattedValue = new Intl.DateTimeFormat(locale || layout.locale, options).format(date);
    return formattedValue;
  };
  return dateTimeFormat;
}

// src/useDebounce/useDebounce.ts
import { useEffect as useEffect9, useState as useState5 } from "react";
function useDebounce(value, msec = 500) {
  const [debouncedValue, setDebouncedValue] = useState5(value);
  useEffect9(() => {
    const timer = setTimeout(() => setDebouncedValue(value), msec);
    return () => {
      clearTimeout(timer);
    };
  }, [value, msec]);
  return debouncedValue;
}

// src/useDebounceCallback/useDebounceCallback.ts
import { useCallback, useRef as useRef5 } from "react";
function useDebounceCallback(callback, msec = 500) {
  const timeout = useRef5();
  return useCallback((...args) => {
    const later = () => {
      clearTimeout(timeout.current);
      callback(...args);
    };
    clearTimeout(timeout.current);
    timeout.current = setTimeout(later, msec);
  }, [callback, msec]);
}

// src/useDebugChangedProps/useDebugChangedProps.ts
import { useEffect as useEffect10, useRef as useRef6 } from "react";
function useDebugChangedProps(props) {
  const ref = useRef6(props);
  useEffect10(() => {
    const changedProps = Object.entries(props).reduce((object, [key, value]) => {
      if (ref.current[key] !== value) {
        object[key] = [ref.current[key], value];
      }
      return object;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log("Changed props:", changedProps);
    }
    ref.current = props;
  });
}

// src/useDomObserver/useDomObserver.ts
import { useEffect as useEffect11 } from "react";
function useDomObserver(ref, callback = () => {
}) {
  const config = { attributes: false, childList: true, subtree: true };
  useEffect11(() => {
    if (!ref || !ref.current) {
      return;
    }
    let unmount = false;
    const done = (...params) => {
      if (unmount) {
        return;
      }
      callback(...params);
    };
    const observer = new MutationObserver(done);
    observer.observe(ref.current, config);
    return () => {
      unmount = true;
      observer.disconnect();
    };
  }, [ref]);
}

// src/useUI/useUI.ts
import { create } from "zustand";
var useUI = create((set, get) => ({
  views: {},
  actions: {
    reduce: (key, reducer) => {
      const views = __spreadValues({}, get().views);
      const newViews = __spreadValues({}, views);
      const value = reducer(views);
      newViews[key] = value;
      set({
        views: newViews
      });
    }
  }
}));

// src/useDrawer/useDrawer.ts
function useDrawer() {
  const drawer = useUI((state) => state.views.drawer);
  const reduce = useUI((state) => state.actions.reduce);
  function setDrawer(value) {
    reduce("drawer", (views) => value);
  }
  function openDrawer(value) {
    return setDrawer(value);
  }
  function closeDrawer() {
    return setDrawer();
  }
  return [drawer, openDrawer, closeDrawer];
}

// src/useElementSize/useElementSize.ts
import { useCallback as useCallback2, useState as useState6 } from "react";
function useElementSize() {
  const [ref, setRef] = useState6(null);
  const [size, setSize] = useState6({ width: 0, height: 0 });
  const onResize = useCallback2(() => {
    setSize({
      width: (ref == null ? void 0 : ref.offsetWidth) || 0,
      height: (ref == null ? void 0 : ref.offsetHeight) || 0
    });
  }, [ref == null ? void 0 : ref.offsetHeight, ref == null ? void 0 : ref.offsetWidth]);
  useEventListener("resize", onResize);
  useIsomorphicLayoutEffect(() => {
    onResize();
  }, [ref == null ? void 0 : ref.offsetHeight, ref == null ? void 0 : ref.offsetWidth]);
  return [setRef, size];
}

// src/useExtra/useExtra.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var [useExtra, ExtraContextProvider] = createGenericContext({});
function ExtraProvider({ children, extra }) {
  return /* @__PURE__ */ jsx2(ExtraContextProvider, { value: extra, children });
}

// src/useFilters/filter.ts
var FilterMode = /* @__PURE__ */ ((FilterMode2) => {
  FilterMode2["SELECT"] = "select";
  FilterMode2["AND"] = "and";
  FilterMode2["OR"] = "or";
  FilterMode2["QUERY"] = "query";
  return FilterMode2;
})(FilterMode || {});
var Filter = class {
  constructor(options) {
    this.id = "filter";
    this.title = "Filter";
    this.mode = "or" /* OR */;
    this.options = [];
    this.values = [];
    if (options) {
      Object.assign(this, options);
    }
    if (this.mode === "select" /* SELECT */) {
      this.options.unshift({
        id: -1,
        // !!! should be undefined
        title: "select"
      });
    }
  }
  static fromFeatureType(featureType, mode = "and" /* AND */) {
    return new Filter({
      id: featureType.id,
      title: featureType.title,
      mode,
      options: featureType.features
    });
  }
  filter(item, value) {
    console.warn("filter not defined for", item, value);
    return true;
  }
  match(item) {
    let match;
    if (this.mode === "or" /* OR */) {
      match = this.values.length ? false : true;
      this.values.forEach((value) => {
        match = match || this.filter(item, value);
      });
    } else {
      match = true;
      this.values.forEach((value) => {
        match = match && this.filter(item, value);
      });
    }
    return match;
  }
  removeInvalidOptions(items) {
    if (this.options) {
      this.options = this.options.filter((option) => {
        const hasItemWithOption = items.reduce((p, item) => {
          return p || this.filter(item, option.id);
        }, false);
        return hasItemWithOption;
      });
    }
  }
  getLabel() {
    if (this.hasAny()) {
      return this.options.filter((x) => x.id && this.values.indexOf(x.id) !== -1).map((x) => x.title).join(", ");
    } else {
      return null;
    }
  }
  hasAny() {
    return this.values.length > 0;
  }
  getCount() {
    return this.options.reduce((p, option) => {
      return p + (option.count || 0);
    }, 0);
  }
  hasResults() {
    return this.getCount() > 0;
  }
  has(option) {
    return this.values.indexOf(option.id) !== -1;
  }
  set(option) {
    if (this.mode === "query" /* QUERY */) {
      this.values = option ? [option.toString()] : [];
    } else if (this.mode === "select" /* SELECT */) {
      this.values = option.id != null ? [option.id] : [];
    } else {
      const index = this.values.indexOf(option.id);
      if (index === -1) {
        if (option.id != null) {
          this.values.push(option.id);
        }
      }
    }
  }
  remove(option) {
    const index = this.values.indexOf(option.id);
    if (index !== -1) {
      this.values.splice(index, 1);
    }
  }
  toggle(option) {
    if (this.has(option)) {
      this.remove(option);
    } else {
      this.set(option);
    }
  }
  clear() {
    this.values = [];
  }
};

// src/useFilters/filter.service.ts
function getFilters(items, featureTypes, filterMap, params) {
  return featureTypes.map((featureType) => {
    const filter = Filter.fromFeatureType(featureType, featureType.mode || "or" /* OR */);
    filter.filter = (item, value) => {
      if (typeof filterMap === "function") {
        return filterMap(featureType.id, item, value);
      }
      return false;
    };
    filter.removeInvalidOptions(items);
    if (params && params[filter.id] != null) {
      filter.values = params[filter.id];
    }
    return filter;
  });
}
function getFilteredItems(items, selectedFilters) {
  const filteredItems = items.filter((item) => {
    let has = true;
    selectedFilters.forEach((filter) => {
      has = has && filter.match(item);
    });
    return has;
  });
  return filteredItems;
}
function setFilters(items, filters, filter, values) {
  if (filter) {
    filter.values = values || [];
  }
  const selectedFilters = filters.filter((x) => x.values.length > 0);
  const filteredItems = getFilteredItems(items, selectedFilters);
  filters.forEach((filter2) => {
    const otherFilters = selectedFilters.filter((x) => x !== filter2);
    const filteredItems2 = getFilteredItems(items, otherFilters);
    if (filter2.options) {
      filter2.options.forEach((option) => {
        let count = 0;
        if (option.id) {
          let i = 0;
          while (i < filteredItems2.length) {
            const item = filteredItems2[i];
            if (filter2.filter(item, option.id)) {
              count++;
            }
            i++;
          }
        } else {
          count = filteredItems2.length;
        }
        option.count = count;
        option.disabled = count === 0;
      });
    }
  });
  return filteredItems;
}
function filtersToParams(filters) {
  const params = {};
  let any = false;
  filters.filter((x) => x.hasAny()).forEach((filter) => {
    params[filter.id] = filter.values;
    any = true;
  });
  if (!any) {
    return null;
  }
  return params;
}

// src/useFilters/useFilters.ts
import { useCallback as useCallback3, useEffect as useEffect12, useMemo as useMemo3, useState as useState7 } from "react";
function useFilters(items, featureTypes, filterItem, initialValues) {
  const filters = useMemo3(() => {
    return getFilters(items, featureTypes, filterItem, initialValues);
  }, [items, featureTypes, filterItem]);
  const [filteredItems, setFilteredItems] = useState7(() => setFilters(items, filters));
  const itemsWithOmittedKeys = useCallback3((...keys) => {
    const filtersWithOmittedKeys = filters.filter((x) => !keys.includes(x.id));
    const filteredItems2 = setFilters(items, filtersWithOmittedKeys);
    return filteredItems2;
  }, [items, filters]);
  const setFilter = useCallback3((filter, values) => {
    const filteredItems2 = setFilters(items, filters, filter, values);
    setFilteredItems(filteredItems2);
  }, [items, filters]);
  useEffect12(() => {
    setFilter();
  }, []);
  return { filteredItems, filters, setFilter, itemsWithOmittedKeys };
}

// src/useFocusTrap/useFocusTrap.ts
import { useState as useState8 } from "react";
function useFocusTrap(ref, options = {}) {
  const selectors = options.selectors || 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
  const [state, setState] = useState8(!options.disabled);
  useIsomorphicLayoutEffect(() => {
    const element = ref.current;
    if (element) {
      const elements = element.querySelectorAll(selectors);
      const first = elements[0];
      const last = elements[elements.length - 1];
      const onKeyDown = (event) => {
        const isTabPressed = event.key === "Tab";
        if (!isTabPressed) {
          return;
        }
        if (event.shiftKey) {
          if (document.activeElement === first) {
            last.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === last) {
            first.focus();
            event.preventDefault();
          }
        }
      };
      element.addEventListener("keydown", onKeyDown);
      return () => {
        element.removeEventListener("keydown", onKeyDown);
      };
    }
    return () => {
    };
  }, [ref.current]);
  return [state, setState];
}

// src/useGeolocation/geolocation.service.ts
function getCurrentPosition(options) {
  return new Promise((resolve, reject) => {
    if (!hasGeolocation()) {
      reject("geolocation not available");
    }
    navigator.geolocation.getCurrentPosition((event) => {
      const result = {
        loading: false,
        accuracy: event.coords.accuracy,
        altitude: event.coords.altitude,
        altitudeAccuracy: event.coords.altitudeAccuracy,
        heading: event.coords.heading,
        latitude: event.coords.latitude,
        longitude: event.coords.longitude,
        speed: event.coords.speed,
        timestamp: event.timestamp
      };
      resolve(result);
    }, (error) => {
      const sensorError = {
        loading: false,
        error,
        accuracy: null,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        latitude: null,
        longitude: null,
        speed: null,
        timestamp: Date.now()
      };
      reject(sensorError);
    }, options);
  });
}
function hasGeolocation() {
  return Boolean(navigator && navigator.geolocation);
}

// src/useGeolocation/useGeolocation.ts
import { useEffect as useEffect13, useState as useState9 } from "react";
function useGeolocation(options) {
  const [state, setState] = useState9({
    loading: true,
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    latitude: null,
    longitude: null,
    speed: null,
    timestamp: Date.now()
  });
  let mounted = true;
  let watchId;
  const onEvent = (event) => {
    if (mounted) {
      setState({
        loading: false,
        accuracy: event.coords.accuracy,
        altitude: event.coords.altitude,
        altitudeAccuracy: event.coords.altitudeAccuracy,
        heading: event.coords.heading,
        latitude: event.coords.latitude,
        longitude: event.coords.longitude,
        speed: event.coords.speed,
        timestamp: event.timestamp
      });
    }
  };
  const onEventError = (error) => mounted && setState((oldState) => __spreadProps(__spreadValues({}, oldState), { loading: false, error }));
  useEffect13(() => {
    if (!hasGeolocation()) {
      return;
    }
    navigator.geolocation.getCurrentPosition(onEvent, onEventError, options);
    watchId = navigator.geolocation.watchPosition(onEvent, onEventError, options);
    return () => {
      mounted = false;
      navigator.geolocation.clearWatch(watchId);
    };
  }, []);
  return state;
}

// src/useIdle/useIdle.ts
import { useEffect as useEffect14, useRef as useRef7, useState as useState10 } from "react";
function useIdle(delay = 3e3, immediate = false) {
  const [isIdle, setIsIdle] = useState10(false);
  const timeoutId = useRef7();
  const goInactive = () => {
    setIsIdle(true);
  };
  const onStartTimer = () => {
    timeoutId.current = setTimeout(goInactive, delay);
  };
  const goActive = () => {
    setIsIdle(false);
    onStartTimer();
  };
  const onResetTimer = () => {
    clearTimeout(timeoutId.current);
    goActive();
  };
  const setup = () => {
    document.addEventListener("mousemove", onResetTimer, false);
    document.addEventListener("mousedown", onResetTimer, false);
    document.addEventListener("keypress", onResetTimer, false);
    document.addEventListener("DOMMouseScroll", onResetTimer, false);
    document.addEventListener("mousewheel", onResetTimer, false);
    document.addEventListener("touchmove", onResetTimer, false);
    document.addEventListener("MSPointerMove", onResetTimer, false);
    window.addEventListener("blur", onStartTimer, false);
    window.addEventListener("focus", onResetTimer, false);
    if (immediate) {
      onStartTimer();
    }
  };
  const cleanUp = () => {
    document.removeEventListener("mousemove", onResetTimer);
    document.removeEventListener("mousedown", onResetTimer);
    document.removeEventListener("keypress", onResetTimer);
    document.removeEventListener("DOMMouseScroll", onResetTimer);
    document.removeEventListener("mousewheel", onResetTimer);
    document.removeEventListener("touchmove", onResetTimer);
    document.removeEventListener("MSPointerMove", onResetTimer);
    window.removeEventListener("blur", onStartTimer);
    window.removeEventListener("focus", onResetTimer);
    clearTimeout(timeoutId.current);
  };
  useEffect14(() => {
    setup();
    return () => {
      cleanUp();
    };
  });
  return isIdle;
}

// src/useInfiniteLoader/useInfiniteLoader.ts
import { useEffect as useEffect15, useMemo as useMemo4, useState as useState11 } from "react";
function useInfiniteLoader(items, perPage = 12, delayInMs = 100) {
  const total = items.length;
  const [position, setPosition] = useState11(Math.min(total, perPage));
  const [hasMore, setHasMore] = useState11(position < total);
  const [more, setMore] = useState11(0);
  useEffect15(() => {
    const nextPosition = Math.min(total, perPage);
    setPosition(nextPosition);
    setMore(0);
    setHasMore(nextPosition < total);
  }, [items]);
  const visibleItems = useMemo4(() => items.slice(0, position), [items, position]);
  const loadMore = () => {
    setMore(more + 1);
  };
  useEffect15(() => {
    if (hasMore && more > 0) {
      const timer = setTimeout(() => {
        const nextPosition = Math.min(total, position + perPage);
        setPosition(nextPosition);
        setHasMore(nextPosition < total);
      }, delayInMs);
      return () => {
        clearTimeout(timer);
      };
    }
    return;
  }, [more, delayInMs]);
  return [visibleItems, loadMore, hasMore];
}

// src/useIntersectionObserver/useIntersectionObserver.ts
import { useCallback as useCallback4, useEffect as useEffect16, useRef as useRef8, useState as useState12 } from "react";
function useIntersectionObserver(ref, options = {}) {
  const {
    threshold = 1,
    root = null,
    rootMargin = "0px"
  } = options;
  const [entry, setEntry] = useState12();
  const previousObserver = useRef8();
  const init = useCallback4((node) => {
    if (previousObserver.current) {
      previousObserver.current.disconnect();
      previousObserver.current = void 0;
    }
    if (isElement(node)) {
      const observer = new IntersectionObserver(([entry2]) => {
        setEntry(entry2);
      }, { threshold, root, rootMargin });
      observer.observe(node);
      previousObserver.current = observer;
    }
  }, [threshold, root, rootMargin]);
  useEffect16(() => {
    if (ref.current) {
      init(ref.current);
    }
  }, [init, ref]);
  const isIntersecting = entry ? entry.isIntersecting : false;
  return isIntersecting;
}
function isElement(node) {
  return (node == null ? void 0 : node.nodeType) === Node.ELEMENT_NODE;
}

// src/useKeyboard/useKeyboard.ts
import { useEffect as useEffect18 } from "react";

// src/useKeyboard/codes.ts
var KeyCode = /* @__PURE__ */ ((KeyCode2) => {
  KeyCode2[KeyCode2["Unknown"] = 0] = "Unknown";
  KeyCode2[KeyCode2["Backspace"] = 8] = "Backspace";
  KeyCode2[KeyCode2["Tab"] = 9] = "Tab";
  KeyCode2[KeyCode2["Enter"] = 13] = "Enter";
  KeyCode2[KeyCode2["Shift"] = 16] = "Shift";
  KeyCode2[KeyCode2["Ctrl"] = 17] = "Ctrl";
  KeyCode2[KeyCode2["Alt"] = 18] = "Alt";
  KeyCode2[KeyCode2["PauseBreak"] = 19] = "PauseBreak";
  KeyCode2[KeyCode2["CapsLock"] = 20] = "CapsLock";
  KeyCode2[KeyCode2["Escape"] = 27] = "Escape";
  KeyCode2[KeyCode2["Space"] = 32] = "Space";
  KeyCode2[KeyCode2["PageUp"] = 33] = "PageUp";
  KeyCode2[KeyCode2["PageDown"] = 34] = "PageDown";
  KeyCode2[KeyCode2["End"] = 35] = "End";
  KeyCode2[KeyCode2["Home"] = 36] = "Home";
  KeyCode2[KeyCode2["LeftArrow"] = 37] = "LeftArrow";
  KeyCode2[KeyCode2["UpArrow"] = 38] = "UpArrow";
  KeyCode2[KeyCode2["RightArrow"] = 39] = "RightArrow";
  KeyCode2[KeyCode2["DownArrow"] = 40] = "DownArrow";
  KeyCode2[KeyCode2["Insert"] = 45] = "Insert";
  KeyCode2[KeyCode2["Delete"] = 46] = "Delete";
  KeyCode2[KeyCode2["KEY_0"] = 48] = "KEY_0";
  KeyCode2[KeyCode2["KEY_1"] = 49] = "KEY_1";
  KeyCode2[KeyCode2["KEY_2"] = 50] = "KEY_2";
  KeyCode2[KeyCode2["KEY_3"] = 51] = "KEY_3";
  KeyCode2[KeyCode2["KEY_4"] = 52] = "KEY_4";
  KeyCode2[KeyCode2["KEY_5"] = 53] = "KEY_5";
  KeyCode2[KeyCode2["KEY_6"] = 54] = "KEY_6";
  KeyCode2[KeyCode2["KEY_7"] = 55] = "KEY_7";
  KeyCode2[KeyCode2["KEY_8"] = 56] = "KEY_8";
  KeyCode2[KeyCode2["KEY_9"] = 57] = "KEY_9";
  KeyCode2[KeyCode2["KEY_A"] = 65] = "KEY_A";
  KeyCode2[KeyCode2["KEY_B"] = 66] = "KEY_B";
  KeyCode2[KeyCode2["KEY_C"] = 67] = "KEY_C";
  KeyCode2[KeyCode2["KEY_D"] = 68] = "KEY_D";
  KeyCode2[KeyCode2["KEY_E"] = 69] = "KEY_E";
  KeyCode2[KeyCode2["KEY_F"] = 70] = "KEY_F";
  KeyCode2[KeyCode2["KEY_G"] = 71] = "KEY_G";
  KeyCode2[KeyCode2["KEY_H"] = 72] = "KEY_H";
  KeyCode2[KeyCode2["KEY_I"] = 73] = "KEY_I";
  KeyCode2[KeyCode2["KEY_J"] = 74] = "KEY_J";
  KeyCode2[KeyCode2["KEY_K"] = 75] = "KEY_K";
  KeyCode2[KeyCode2["KEY_L"] = 76] = "KEY_L";
  KeyCode2[KeyCode2["KEY_M"] = 77] = "KEY_M";
  KeyCode2[KeyCode2["KEY_N"] = 78] = "KEY_N";
  KeyCode2[KeyCode2["KEY_O"] = 79] = "KEY_O";
  KeyCode2[KeyCode2["KEY_P"] = 80] = "KEY_P";
  KeyCode2[KeyCode2["KEY_Q"] = 81] = "KEY_Q";
  KeyCode2[KeyCode2["KEY_R"] = 82] = "KEY_R";
  KeyCode2[KeyCode2["KEY_S"] = 83] = "KEY_S";
  KeyCode2[KeyCode2["KEY_T"] = 84] = "KEY_T";
  KeyCode2[KeyCode2["KEY_U"] = 85] = "KEY_U";
  KeyCode2[KeyCode2["KEY_V"] = 86] = "KEY_V";
  KeyCode2[KeyCode2["KEY_W"] = 87] = "KEY_W";
  KeyCode2[KeyCode2["KEY_X"] = 88] = "KEY_X";
  KeyCode2[KeyCode2["KEY_Y"] = 89] = "KEY_Y";
  KeyCode2[KeyCode2["KEY_Z"] = 90] = "KEY_Z";
  KeyCode2[KeyCode2["Meta"] = 91] = "Meta";
  KeyCode2[KeyCode2["F1"] = 112] = "F1";
  KeyCode2[KeyCode2["F2"] = 113] = "F2";
  KeyCode2[KeyCode2["F3"] = 114] = "F3";
  KeyCode2[KeyCode2["F4"] = 115] = "F4";
  KeyCode2[KeyCode2["F5"] = 116] = "F5";
  KeyCode2[KeyCode2["F6"] = 117] = "F6";
  KeyCode2[KeyCode2["F7"] = 118] = "F7";
  KeyCode2[KeyCode2["F8"] = 119] = "F8";
  KeyCode2[KeyCode2["F9"] = 120] = "F9";
  KeyCode2[KeyCode2["F10"] = 121] = "F10";
  KeyCode2[KeyCode2["F11"] = 122] = "F11";
  KeyCode2[KeyCode2["F12"] = 123] = "F12";
  KeyCode2[KeyCode2["NumLock"] = 144] = "NumLock";
  KeyCode2[KeyCode2["ScrollLock"] = 145] = "ScrollLock";
  KeyCode2[KeyCode2["Equal"] = 187] = "Equal";
  KeyCode2[KeyCode2["Minus"] = 189] = "Minus";
  KeyCode2[KeyCode2["Backquote"] = 192] = "Backquote";
  KeyCode2[KeyCode2["Backslash"] = 220] = "Backslash";
  return KeyCode2;
})(KeyCode || {});
var KeyMod = /* @__PURE__ */ ((KeyMod2) => {
  KeyMod2[KeyMod2["CtrlCmd"] = 2048] = "CtrlCmd";
  KeyMod2[KeyMod2["Shift"] = 1024] = "Shift";
  KeyMod2[KeyMod2["Alt"] = 512] = "Alt";
  KeyMod2[KeyMod2["WinCtrl"] = 256] = "WinCtrl";
  return KeyMod2;
})(KeyMod || {});

// src/useSSR/useSSR.ts
import { useEffect as useEffect17, useState as useState13 } from "react";
var detectIsBrowser = () => {
  return Boolean(
    typeof window !== "undefined" && window.document && window.document.createElement
  );
};
function useSSR() {
  const [browser, setBrowser] = useState13(false);
  useEffect17(() => {
    setBrowser(detectIsBrowser());
  }, []);
  return {
    isBrowser: browser,
    isServer: !browser
  };
}

// src/useKeyboard/helper.ts
function getCtrlKeysByPlatform() {
  return {
    CtrlCmd: isMac() ? "metaKey" : "ctrlKey",
    WinCtrl: isMac() ? "ctrlKey" : "metaKey"
  };
}
function getActiveModMap(bindings) {
  const modBindings = bindings.filter((item) => !!KeyMod[item]);
  const activeModMap = {
    CtrlCmd: false,
    Shift: false,
    Alt: false,
    WinCtrl: false
  };
  modBindings.forEach((code) => {
    const modKey = KeyMod[code];
    activeModMap[modKey] = true;
  });
  return activeModMap;
}
function isMac() {
  if (!detectIsBrowser()) {
    return false;
  }
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
}

// src/useKeyboard/useKeyboard.ts
var useKeyboard = (handler, keyBindings, options = {}) => {
  const bindings = Array.isArray(keyBindings) ? keyBindings : [keyBindings];
  const {
    disableGlobalEvent = false,
    capture = false,
    stopPropagation = false,
    preventDefault = true,
    event = "keydown"
  } = options;
  const activeModMap = getActiveModMap(bindings);
  const keyCode = bindings.filter((item) => !KeyMod[item]);
  const { CtrlCmd, WinCtrl } = getCtrlKeysByPlatform();
  const eventHandler = (event2) => {
    if (activeModMap.Shift && !event2.shiftKey)
      return;
    if (activeModMap.Alt && !event2.altKey)
      return;
    if (activeModMap.CtrlCmd && !event2[CtrlCmd])
      return;
    if (activeModMap.WinCtrl && !event2[WinCtrl])
      return;
    const hitOne = keyCode.find((k) => k === event2.keyCode);
    if (keyCode && !hitOne)
      return;
    if (stopPropagation) {
      event2.stopPropagation();
    }
    if (preventDefault) {
      event2.preventDefault();
    }
    handler && handler(event2);
  };
  useEffect18(() => {
    if (!disableGlobalEvent) {
      document.addEventListener(event, eventHandler);
    }
    return () => {
      document.removeEventListener(event, eventHandler);
    };
  }, [disableGlobalEvent]);
  const elementBindingHandler = (elementEventType, isCapture = false) => {
    if (elementEventType !== event)
      return () => {
      };
    if (isCapture !== capture)
      return () => {
      };
    return (e) => eventHandler(e);
  };
  return {
    bindings: {
      onKeyDown: elementBindingHandler("keydown"),
      onKeyDownCapture: elementBindingHandler("keydown", true),
      onKeyPress: elementBindingHandler("keypress"),
      onKeyPressCapture: elementBindingHandler("keypress", true),
      onKeyUp: elementBindingHandler("keyup"),
      onKeyUpCapture: elementBindingHandler("keyup", true)
    }
  };
};

// src/useLabel/useLabel.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var [useLabel, LabelContextProvider] = createGenericContext();
function LabelProvider({ children }) {
  const { labels } = useLayout();
  const labelService = new LabelService(labels);
  const getLabel = (key, params) => {
    return labelService.getLabel(key, params);
  };
  return /* @__PURE__ */ jsx3(LabelContextProvider, { value: getLabel, children });
}
var LabelService = class {
  constructor(labels) {
    this.labels = labels;
    this.dictionary = Object.fromEntries(labels.map((l) => [l.id, l.text]));
  }
  getLabel(key, params) {
    return parseLabel(this.dictionary, key, params);
  }
};
function parseLabel(dictionary, key, params) {
  const label = dictionary[key] != null ? dictionary[key] : key;
  if (params) {
    return parseParams(label, params);
  }
  return label;
}
function parseParams(label, params) {
  const TEMPLATE_REGEXP = /@(\w+)/g;
  return label.replace(TEMPLATE_REGEXP, (text, key) => {
    const replacer = params[key];
    return typeof replacer !== "undefined" ? String(replacer) : text;
  });
}

// src/useLazyModules/useLazyModules.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var [useLazyModules, LazyModulesContextProvider] = createGenericContext({});
function LazyModulesProvider({ children, modules }) {
  return /* @__PURE__ */ jsx4(LazyModulesContextProvider, { value: modules, children });
}

// src/useMetaData/useMetaData.tsx
import { defaultLocale, defaultMarket } from "@websolutespa/bom-core";
import { getPublicUrl, resolveHref } from "@websolutespa/bom-mixer-models";
import { convert as htmlToText } from "html-to-text";
import { useRouter } from "next/router";
import { useMemo as useMemo5 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var [useMetaData, MetaDataContextProvider] = createGenericContext();
function MetaDataProvider({ children, metaData }) {
  var _a, _b, _c, _d, _e;
  const router = useRouter();
  const layout = useLayout();
  const page = usePage();
  const brand = __spreadProps(__spreadValues({}, metaData.brand), {
    logo: resolveHref(metaData.brand.logo),
    url: getPublicUrl(),
    // layout.topLevelHrefs.homepage,
    businessName: metaData.brand.businessName || metaData.brand.name,
    appName: metaData.brand.appName || metaData.brand.name
  });
  const title = htmlToText(((_a = page.meta) == null ? void 0 : _a.title) || page.title || "");
  const description = htmlToText(((_b = page.meta) == null ? void 0 : _b.description) || page.abstract || "");
  const media = ((_c = page.meta) == null ? void 0 : _c.image) || page.media;
  const image = media ? resolveHref(media.src || media.url) : brand.logo;
  const canonical = resolveHref(page.href);
  const queryIndex = router.asPath.indexOf("?");
  const url = `${canonical}${queryIndex !== -1 ? router.asPath.substring(queryIndex) : ""}`;
  const alternates = useMemo5(() => {
    const alternates2 = [];
    page.alternates.forEach((alternate) => {
      const market = layout.markets.find((x) => x.id === alternate.market);
      if (market) {
        if (market.countries && market.countries.length > 0) {
          market.countries.forEach((country) => {
            const alpha2Code = typeof country === "string" ? country : country.alpha2Code;
            alternates2.push({
              id: `${alternate.market}-${alternate.locale}-${alpha2Code}`,
              href: resolveHref(alternate.id),
              hrefLang: `${alternate.locale}-${alpha2Code}`
            });
          });
        } else {
          alternates2.push({
            id: `${alternate.market}-${alternate.locale}`,
            href: resolveHref(alternate.id),
            hrefLang: alternate.locale
          });
        }
      }
    });
    return alternates2;
  }, [layout, page]);
  const xDefault = useMemo5(() => {
    var _a2, _b2;
    const xDefaultMarket = ((_a2 = layout.markets.find((x) => x.isDefault)) == null ? void 0 : _a2.id) || defaultMarket;
    const xDefaultLocale = ((_b2 = layout.locales.find((x) => x.isDefault)) == null ? void 0 : _b2.id) || defaultLocale;
    const alternate = page.alternates.find((x) => x.market === xDefaultMarket && x.locale === xDefaultLocale);
    if (alternate) {
      return {
        id: `${alternate.market}-${alternate.locale}`,
        href: resolveHref(alternate.id),
        hrefLang: alternate.locale
      };
    }
    return void 0;
  }, [layout, page]);
  const meta = {
    title,
    description,
    image,
    keywords: (_d = page.meta) == null ? void 0 : _d.keywords,
    robots: (_e = page.meta) == null ? void 0 : _e.robots,
    slug: page.href,
    url,
    canonical,
    alternates,
    xDefault
  };
  const contactPoint = {
    "@type": "ContactPoint",
    telephone: brand.telephone,
    email: brand.email,
    contactType: "customer service",
    areaServed: layout.locales.map((x) => x.id),
    availableLanguage: layout.locales.map((x) => x.id)
  };
  const postalAddress = {
    "@type": "PostalAddress",
    streetAddress: brand.address,
    addressLocality: brand.city,
    postalCode: brand.zipCode,
    addressRegion: brand.provinceCode,
    addressCountry: brand.countryCode
  };
  const organization = {
    "@type": "Organization",
    name: brand.businessName,
    logo: {
      "@type": "ImageObject",
      url: brand.logo
    },
    url: brand.url
    /*
    foundingDate: '2020-01-01',
    numberOfEmployees: {
      '@type': 'QuantitativeValue',
      value: 150,
    },
    */
  };
  const hasContact = Boolean(brand.email || brand.telephone);
  if (hasContact) {
    organization.contactPoint = contactPoint;
  }
  const hasAddress = Boolean(brand.address || brand.city || brand.zipCode || brand.provinceCode || brand.countryCode);
  if (hasAddress) {
    organization.address = postalAddress;
  }
  if (brand.social) {
    organization.sameAs = Object.values(brand.social);
  }
  const structuredData = metaData.structuredData || {
    "@type": "WebPage",
    name: title,
    url,
    description,
    publisher: organization
  };
  const openGraph = metaData.openGraph || {
    type: "website",
    title,
    description,
    url,
    siteName: brand.name,
    image,
    locale: layout.locale
  };
  const twitterCard = metaData.twitterCard || (brand.twitterName ? {
    card: "summary_large_image",
    title,
    description,
    image,
    imageAlt: brand.businessName,
    site: brand.twitterName,
    creator: brand.twitterName
  } : void 0);
  const value = {
    layout,
    page,
    brand,
    contactPoint,
    meta,
    openGraph,
    organization,
    postalAddress,
    structuredData,
    twitterCard
  };
  return /* @__PURE__ */ jsx5(MetaDataContextProvider, { value, children });
}

// src/useModal/useModal.ts
function useModal() {
  const modal = useUI((state) => state.views.modal);
  const reduce = useUI((state) => state.actions.reduce);
  function setModal(value) {
    reduce("modal", (views) => value);
  }
  function openModal(value) {
    return setModal(value);
  }
  function closeModal() {
    return setModal();
  }
  return [modal, openModal, closeModal];
}

// src/useMounted/useMounted.ts
import { useEffect as useEffect19, useState as useState14 } from "react";
function useMounted() {
  const [mounted, setMounted] = useState14(false);
  useEffect19(() => {
    setMounted(true);
  }, []);
  return mounted;
}

// src/usePage/usePage.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var [usePage, PageContextProvider] = createGenericContext();
function PageProvider({ children, page }) {
  return /* @__PURE__ */ jsx6(PageContextProvider, { value: page, children });
}

// src/usePageLoading/usePageLoading.ts
import { Router } from "next/router";
import { useEffect as useEffect20, useState as useState15 } from "react";
function getSearchParams(route) {
  const components = route.split("?");
  const search = components[1] || "";
  const searchParams = new URLSearchParams(search);
  return Object.fromEntries(searchParams);
}
function getPageRoute(route) {
  const pageRoute = {
    pathname: route.split("?")[0],
    query: getSearchParams(route),
    asPath: route
  };
  return pageRoute;
}
function usePageLoading(options = { loading: false }) {
  const [loading, setLoading] = useState15(options.loading);
  const [error, setError] = useState15();
  const [pageRoute, setPageRoute] = useState15();
  const [previousPageRoute, setPreviousPageRoute] = useState15();
  useEffect20(() => {
    let previousRoute;
    const onRouteChangeStart = (route, options2) => {
      const pageRoute2 = previousRoute ? getPageRoute(previousRoute) : void 0;
      setError();
      setPreviousPageRoute(pageRoute2);
      if (options2 == null ? void 0 : options2.shallow) {
        return;
      }
      setLoading(true);
    };
    const onRouteChangeComplete = (route, options2) => {
      const pageRoute2 = getPageRoute(route);
      setPageRoute(pageRoute2);
      previousRoute = route;
      if (options2 == null ? void 0 : options2.shallow) {
        return;
      }
      setLoading(false);
    };
    const onRouteChangeError = (error2, route, options2) => {
      console.log("usePageLoading.onRouteChangeError", error2);
      setError(error2);
      if (options2 == null ? void 0 : options2.shallow) {
        return;
      }
      setLoading(false);
    };
    Router.events.on("routeChangeStart", onRouteChangeStart);
    Router.events.on("routeChangeComplete", onRouteChangeComplete);
    Router.events.on("routeChangeError", onRouteChangeError);
    return () => {
      Router.events.off("routeChangeStart", onRouteChangeStart);
      Router.events.off("routeChangeComplete", onRouteChangeComplete);
      Router.events.off("routeChangeError", onRouteChangeError);
    };
  }, []);
  return { loading, error, pageRoute, previousPageRoute };
}

// src/usePagination/pagination.service.ts
import { isArray, isObject } from "@websolutespa/bom-core";
function isPaginationInfo(item) {
  return isObject(item) && (typeof item.page === "number" && typeof item.pages === "number" && typeof item.perPage === "number" && typeof item.total === "number" && isArray(item.items));
}
function getPagedItems(items, page, perPage) {
  const from = (page - 1) * perPage;
  const to = Math.min(page * perPage, items.length);
  return items.slice(from, to);
}
function getMoreItems(items, page, perPage) {
  const total = items.length;
  const position = Math.min(total, perPage * page);
  return items.slice(0, position);
}
function getPaginationInfo(items, options) {
  const mode = (options == null ? void 0 : options.mode) || "pagination";
  const page = (options == null ? void 0 : options.page) || 1;
  const perPage = (options == null ? void 0 : options.perPage) || 12;
  const total = items.length;
  const pages = Math.ceil(total / perPage);
  const hasMore = page < pages;
  const prevPage = page > 1 ? page - 1 : void 0;
  const nextPage = page < pages ? page + 1 : void 0;
  const pagedItems = mode === "pagination" ? getPagedItems(items, page, perPage) : getMoreItems(items, page, perPage);
  return {
    items: pagedItems,
    hasMore,
    nextPage,
    page,
    pages,
    perPage,
    prevPage,
    total
  };
}

// src/usePagination/usePagination.ts
import { useEffect as useEffect21, useMemo as useMemo6, useState as useState16 } from "react";
function usePagination(items, options) {
  const mode = (options == null ? void 0 : options.mode) || "pagination";
  const delayInMs = (options == null ? void 0 : options.delayInMs) || 100;
  const [page, setPage] = useState16((options == null ? void 0 : options.page) || 1);
  const [perPage, setPerPageInner] = useState16((options == null ? void 0 : options.perPage) || 12);
  const [more, setMore] = useState16(0);
  const total = items.length;
  const pages = Math.ceil(total / perPage);
  const hasMore = page < pages;
  const prevPage = page > 1 ? page - 1 : void 0;
  const nextPage = page < pages ? page + 1 : void 0;
  const pagedItems = useMemo6(() => {
    const pagedItems2 = mode === "pagination" ? getPagedItems(items, page, perPage) : getMoreItems(items, page, perPage);
    return pagedItems2;
  }, [items, mode, page, perPage]);
  function goToPage(page2) {
    if (page2 > 0 && page2 <= pages) {
      setPage(page2);
    }
  }
  function goToNextPage() {
    goToPage(page + 1);
  }
  function goToPreviousPage() {
    goToPage(page - 1);
  }
  function setPerPage(perPage2) {
    if (perPage2 > 0) {
      const pages2 = Math.ceil(total / perPage2);
      const newPage = Math.max(1, Math.min(pages2, page));
      setPage(newPage);
      setPerPageInner(perPage2);
    }
  }
  function loadMore() {
    if (hasMore) {
      if (mode === "infinite") {
        setMore(more + 1);
      } else {
        goToNextPage();
      }
      return page + 1;
    } else {
      return page;
    }
  }
  useEffect21(() => {
    if (mode === "infinite" && hasMore && more > 0) {
      const timer = setTimeout(() => {
        setPage(page + 1);
      }, delayInMs);
      return () => {
        clearTimeout(timer);
      };
    }
    return;
  }, [more, delayInMs]);
  return {
    items: pagedItems,
    hasMore,
    nextPage,
    page,
    pages,
    perPage,
    prevPage,
    total,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    loadMore,
    setPerPage
  };
}

// src/usePaginationLegacy/pagination-legacy.service.ts
import { isArray as isArray2, isObject as isObject2 } from "@websolutespa/bom-core";
function isPaginationLegacyInfo(item) {
  return isObject2(item) && (typeof item.page === "number" && typeof item.pages === "number" && typeof item.total === "number" && isArray2(item.items));
}
function getPagedItemsLegacy(items, page, perPage) {
  const from = (page - 1) * perPage;
  const to = Math.min(page * perPage, items.length);
  return items.slice(from, to);
}
function getPaginationLegacyInfo(items, page = 1, perPage = 15) {
  const total = items.length;
  const pages = Math.ceil(total / perPage);
  const pagedItems = getPagedItemsLegacy(items, page, perPage);
  return { items: pagedItems, total, pages, page, perPage };
}

// src/usePaginationLegacy/usePaginationLegacy.ts
import { useEffect as useEffect22, useState as useState17 } from "react";
function usePaginationLegacy($items, $page = 1, $perPage = 15) {
  const total = $items.length;
  const [page, setPage] = useState17($page);
  const [perPage, setPerPage_] = useState17($perPage);
  const [items, setItems] = useState17(getPagedItemsLegacy($items, $page, $perPage));
  const pages = Math.ceil(total / perPage);
  useEffect22(() => {
    setItems(getPagedItemsLegacy($items, page, perPage));
  }, [$items]);
  function goToPage(page2) {
    if (page2 > 0 && page2 <= pages) {
      setPage(page2);
      setItems(getPagedItemsLegacy($items, page2, perPage));
    }
  }
  function setPerPage(perPage2) {
    if (perPage2 > 0) {
      const pages2 = Math.ceil(total / perPage2);
      const newPage = Math.max(1, Math.min(pages2, page));
      setPage(newPage);
      setPerPage_(perPage2);
      setItems(getPagedItemsLegacy($items, newPage, perPage2));
    }
  }
  function nextPage() {
    goToPage(page + 1);
  }
  function previousPage() {
    goToPage(page - 1);
  }
  return { items, page, pages, total, nextPage, previousPage, goToPage, setPerPage };
}

// src/usePortal/usePortal.ts
import { useEffect as useEffect23, useState as useState18 } from "react";
var namespace = "theme";
function usePortal(name = getUID(), getContainer) {
  const { isBrowser: isBrowser5 } = useSSR();
  const id = `${namespace}-${name}`;
  const [portal, setPortal] = useState18(isBrowser5 ? createElementWithId(id) : null);
  useEffect23(() => {
    const container = typeof getContainer === "function" ? getContainer() : null;
    const parentElement = container || document.body;
    const element = parentElement.querySelector(`#${id}`) || createElementWithId(id);
    if (!element.parentElement) {
      parentElement.appendChild(element);
    }
    setPortal(element);
  }, []);
  return portal;
}
function createElementWithId(id) {
  const element = document.createElement("div");
  element.setAttribute("id", id);
  return element;
}
function getUID() {
  return Math.random().toString(32).slice(2, 10);
}

// src/usePrevious/usePrevious.ts
import { useEffect as useEffect24, useRef as useRef9 } from "react";
function usePrevious(state) {
  const ref = useRef9(null);
  useEffect24(() => {
    ref.current = state;
  });
  return ref.current;
}

// src/useRealSize/useRealSize.ts
import { useEffect as useEffect25, useState as useState19 } from "react";
function useRealSize(ref) {
  const [state, setState] = useState19({ width: 0, height: 0 });
  const update = () => {
    const { width, height } = getRealSize(ref.current);
    setState({ width, height });
  };
  useEffect25(() => update(), [ref.current]);
  return [state, update];
}
function getRealSize(element) {
  const defaultSize = { width: 0, height: 0 };
  if (!element || typeof window === "undefined") {
    return defaultSize;
  }
  const rect = element.getBoundingClientRect();
  const { width, height } = window.getComputedStyle(element);
  return {
    width: getComputedValue(`${width}`, rect.width),
    height: getComputedValue(`${height}`, rect.height)
  };
}
function getComputedValue(style, parentNum) {
  if (!style) {
    return 0;
  }
  const value = style.includes("px") ? +style.split("px")[0] : style.includes("%") ? +style.split("%")[0] * parentNum * 0.01 : style;
  return Number.isNaN(+value) ? 0 : +value;
}

// src/useReducedMotion/useReducedMotion.ts
import { isBrowser as isBrowser3 } from "@websolutespa/bom-core";
import { createStore as createStore2, useStore as useStore2 } from "zustand";
import { createJSONStorage as createJSONStorage2, persist as persist2 } from "zustand/middleware";
var QUERY2 = "(prefers-reduced-motion: no-preference)";
function getPreferredReducedMotion() {
  return isBrowser3 && !window.matchMedia(QUERY2).matches;
}
var updateClassList2 = (reducedMotion) => {
  if (isBrowser3) {
    document.documentElement.classList.toggle("--reduced-motion", reducedMotion);
    document.documentElement.classList.toggle("--motion", !reducedMotion);
  }
};
var createReducedMotionStore = (_a) => {
  var _b = _a, {
    name,
    storage
  } = _b, initialState = __objRest(_b, [
    "name",
    "storage"
  ]);
  const defaultState = {
    reducedMotion: true
  };
  const useStore3 = createStore2()(persist2(
    (set, get) => __spreadProps(__spreadValues(__spreadValues({}, defaultState), initialState), {
      actions: {
        setReducedMotion: (reducedMotion) => {
          updateClassList2(reducedMotion);
          set((state) => ({ reducedMotion }));
        },
        toggleReducedMotion: () => {
          const state = get();
          const newReducedMotion = !state.reducedMotion;
          updateClassList2(newReducedMotion);
          set((state2) => ({ reducedMotion: newReducedMotion }));
        }
      }
    }),
    {
      name,
      storage: createJSONStorage2(() => storage || sessionStorage),
      merge: (persistedState, currentState) => {
        const newReducedMotion = (persistedState == null ? void 0 : persistedState.reducedMotion) || getPreferredReducedMotion();
        updateClassList2(newReducedMotion);
        currentState.reducedMotion = newReducedMotion;
        return currentState;
      }
      // getStorage: () => {
      //  return storage || sessionStorage;
      // },
      // onRehydrateStorage: () => () => {
      //  console.log('onRehydrateStorage', useStore, useStore.getState());
      // },
    }
  ));
  return useStore3;
};
var reducedMotionSingletonStore_;
var createReducedMotionSingletonStore = () => {
  reducedMotionSingletonStore_ = reducedMotionSingletonStore_ || createReducedMotionStore({ name: "prefers-reduced-motion" });
  return reducedMotionSingletonStore_;
};
function useReducedMotion(selector) {
  return useStore2(createReducedMotionSingletonStore(), selector);
}

// src/useReducedMotion/useReducedMotionLocal.ts
import { useState as useState20 } from "react";
function useReducedMotionLocal() {
  const reducedMotion = useReducedMotion((state) => state.reducedMotion);
  const [override, setOverride] = useState20(false);
  const setReducedMotionLocal = (reducedMotionLocal2) => {
    setOverride(!reducedMotionLocal2);
  };
  const toggleReducedMotionLocal = () => {
    setOverride(!override);
  };
  const reducedMotionLocal = reducedMotion && !override;
  return {
    reducedMotionLocal,
    setReducedMotionLocal,
    toggleReducedMotionLocal
  };
}

// src/useResize/useResize.ts
function useResize(callback, immediate = true) {
  const handleResize = () => callback();
  useEventListener("resize", handleResize);
  useIsomorphicLayoutEffect(() => {
    if (immediate) {
      handleResize();
    }
  }, []);
}

// src/useScroll/useScroll.ts
import { useState as useState21 } from "react";
function useScroll() {
  const [scroll, setScroll] = useState21({ left: 0, top: 0 });
  const onScroll = () => {
    const left = window.scrollX;
    const top = window.scrollY;
    if (scroll.left !== left || scroll.top !== top) {
      setScroll({ left, top });
    }
  };
  useEventListener("scroll", onScroll);
  useIsomorphicLayoutEffect(() => {
    onScroll();
  }, []);
  return scroll;
}

// src/useScrolled/useScrolled.ts
import { useState as useState22 } from "react";
var DEFAULT_CALLBACK = (top, left) => {
  return top > 0;
};
function useScrolled(callback = DEFAULT_CALLBACK) {
  const [scrolled, setScrolled] = useState22(false);
  const onScrolled = () => {
    const scrolled_ = callback(window.scrollY, window.scrollX);
    if (scrolled !== scrolled_) {
      setScrolled(scrolled_);
    }
  };
  useEventListener("scroll", onScrolled);
  useIsomorphicLayoutEffect(() => {
    onScrolled();
  }, []);
  return scrolled;
}

// src/useScrollTo/useScrollTo.ts
import { isBrowser as isBrowser4 } from "@websolutespa/bom-core";
import { animate } from "framer-motion";
function useScrollTo(offset = 0) {
  const scrollToHash = (event) => {
    const href = event.currentTarget.getAttribute("href");
    if (href && href.indexOf("#") !== -1) {
      const hashId = `#${href.split("#")[1]}`;
      scrollToSelector(hashId, offset);
    }
  };
  return scrollToHash;
}
function scrollToSelector(selector, offset = 0) {
  if (selector && isBrowser4) {
    const element = document.querySelector(selector);
    if (element) {
      const rect = element.getBoundingClientRect();
      scrollToRelativeY(rect.top, offset);
    }
  }
}
function scrollToRelativeY(y = 0, offset = 0) {
  const to = window.scrollY + y - 60 + offset;
  return scrollToY(to);
}
function scrollToY(y = 0) {
  const from = window.scrollY;
  const to = y;
  const duration = Math.sqrt(Math.abs(to - from) / 4e3);
  animate(from, to, {
    duration,
    onUpdate: (v) => window.scrollTo(0, v)
  });
}

// src/useSearchParams/useSearchParams.ts
import { useRouter as useRouter2 } from "next/router";
import { useCallback as useCallback5 } from "react";
function deserialize_(url) {
  const components = url.split("?");
  const search = components[1] || "";
  return new URLSearchParams(search);
}
function serialize_(url, params) {
  const searchParams = deserialize_(url);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      searchParams.set(key, value);
    }
  }
  return searchParams;
}
function searchParamsToObject_(params) {
  const entries = params.entries();
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}
function getSearchParams2(url, key) {
  const params = deserialize_(url);
  const value = key ? params.get(key) : Object.fromEntries(params);
  return value;
}
function updateSearchParams(currentPath, params) {
  const components = currentPath.split("?");
  const searchParams = serialize_(components[1] || "", params);
  const query = searchParamsToObject_(searchParams);
  const pathname = components[0] || "";
  return { pathname, query };
}
function pushSearchParams(router, params) {
  const { pathname, query } = updateSearchParams(router.asPath, params);
  router.push({ pathname, query });
}
function pushSearchParamsSilently(router, params) {
  const { pathname, query } = updateSearchParams(router.asPath, params);
  router.push(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function replaceSearchParams(router, params) {
  const { pathname, query } = updateSearchParams(router.asPath, params);
  router.replace({ pathname, query });
}
function replaceSearchParamsSilently(router, params) {
  const { pathname, query } = updateSearchParams(router.asPath, params);
  router.replace(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function useSearchParams() {
  const router = useRouter2();
  const params = getSearchParams2(router.asPath);
  const pushParams = useCallback5((params2) => {
    pushSearchParams(router, params2);
  }, [router]);
  const pushParamsSilently = useCallback5((params2) => {
    pushSearchParamsSilently(router, params2);
  }, [router]);
  const replaceParams = useCallback5((params2) => {
    replaceSearchParams(router, params2);
  }, [router]);
  const replaceParamsSilently = useCallback5((params2) => {
    replaceSearchParamsSilently(router, params2);
  }, [router]);
  return { params, pushParams, pushParamsSilently, replaceParams, replaceParamsSilently };
}
function useSearchParamsValue(key) {
  const router = useRouter2();
  const params = getSearchParams2(router.asPath, key);
  const pushParams = useCallback5((params2) => {
    pushSearchParams(router, params2);
  }, [router]);
  const pushParamsSilently = useCallback5((params2) => {
    pushSearchParamsSilently(router, params2);
  }, [router]);
  const replaceParams = useCallback5((params2) => {
    replaceSearchParams(router, params2);
  }, [router]);
  const replaceParamsSilently = useCallback5((params2) => {
    replaceSearchParamsSilently(router, params2);
  }, [router]);
  return { params, pushParams, pushParamsSilently, replaceParams, replaceParamsSilently };
}

// src/useSearchParamsEncoded/useSearchParamsEncoded.ts
import { base64ToString, stringToBase64 } from "@websolutespa/bom-core";
import { useRouter as useRouter3 } from "next/router";
import { useCallback as useCallback6 } from "react";
var USE_ENCRYPTION = true;
function stringToURLSearchParams(url) {
  return new URLSearchParams(url);
}
function getURLSearchParams(url, key) {
  const params = stringToURLSearchParams(url);
  return params.get(key);
}
function setURLSearchParams(url, keyOrValue, value) {
  const params = stringToURLSearchParams(url);
  if (value != null) {
    params.set(keyOrValue, value);
  } else {
    params.set(keyOrValue, "");
  }
  return params;
}
function deserialize_2(url, key) {
  const encoded = getURLSearchParams(url, "params");
  return decode(encoded, key);
}
function serialize_2(url, value, key) {
  const params = deserialize_2(url);
  const encoded = encode(params, value, key);
  return setURLSearchParams(url, "params", encoded);
}
function decode(encoded, key) {
  let decoded = null;
  if (encoded) {
    const json = USE_ENCRYPTION ? base64ToString(encoded) : encoded;
    decoded = JSON.parse(json);
  }
  if (key && decoded) {
    decoded = decoded[key];
  }
  return decoded || null;
}
function encode(params, value, key) {
  params = params || {};
  let encoded = null;
  if (typeof key === "string") {
    params[key] = value;
  } else if (typeof value === "object") {
    params = Object.assign(params, value);
  }
  const json = JSON.stringify(params);
  encoded = USE_ENCRYPTION ? stringToBase64(json) : json;
  return encoded;
}
function searchParamsToObject_2(params) {
  const entries = params.entries();
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}
function getSearchParamsEncoded(url, key) {
  const components = url.split("?");
  const search = components[1] || "";
  const searchParams = new URLSearchParams(search);
  const params = searchParams.get("params");
  const value = params ? decode(params, key) : null;
  return value;
}
function updateSearchParamsEncoded(currentPath, value, key) {
  const components = currentPath.split("?");
  const searchParams = serialize_2(components[1] || "", value, key);
  const query = searchParamsToObject_2(searchParams);
  const pathname = components[0] || "";
  return { pathname, query };
}
function pushSearchParamsEncoded(router, value, key) {
  const { pathname, query } = updateSearchParamsEncoded(router.asPath, value, key);
  router.push({ pathname, query });
}
function pushSearchParamsEncodedSilently(router, value, key) {
  const { pathname, query } = updateSearchParamsEncoded(router.asPath, value, key);
  router.push(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function replaceSearchParamsEncoded(router, value, key) {
  const { pathname, query } = updateSearchParamsEncoded(router.asPath, value, key);
  router.replace({ pathname, query });
}
function replaceSearchParamsEncodedSilently(router, value, key) {
  const { pathname, query } = updateSearchParamsEncoded(router.asPath, value, key);
  router.replace(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function useSearchParamsEncoded(key) {
  const router = useRouter3();
  const params = getSearchParamsEncoded(router.asPath, key);
  const pushParams = useCallback6((params2) => {
    pushSearchParamsEncoded(router, params2, key);
  }, [key, router]);
  const pushParamsSilently = useCallback6((params2) => {
    pushSearchParamsEncodedSilently(router, params2, key);
  }, [key, router]);
  const replaceParams = useCallback6((params2) => {
    replaceSearchParamsEncoded(router, params2, key);
  }, [key, router]);
  const replaceParamsSilently = useCallback6((params2) => {
    replaceSearchParamsEncodedSilently(router, params2, key);
  }, [key, router]);
  return { params, pushParams, pushParamsSilently, replaceParams, replaceParamsSilently };
}

// src/useSearchParamsQs/useSearchParamsQs.ts
import { qsDeserializeRaw, qsSerializeRaw } from "@websolutespa/bom-core";
import { useRouter as useRouter4 } from "next/router";
import { useCallback as useCallback7 } from "react";
function deserialize(encoded, key) {
  let decoded = {};
  if (encoded) {
    decoded = qsDeserializeRaw(encoded);
  }
  if (key && decoded) {
    decoded = decoded[key];
  }
  return decoded || {};
}
function encode2(params, value, key) {
  if (key) {
    params = __spreadProps(__spreadValues({}, params), { [key]: value });
  } else if (typeof value === "object") {
    params = __spreadValues(__spreadValues({}, params), value);
  } else {
    params = __spreadValues({}, params);
  }
  const search = qsSerializeRaw(params);
  return { search, params };
}
function serialize(search, value, key) {
  const params = deserialize(search);
  const encoded = encode2(params, value, key);
  return encoded;
}
function getComponents(url) {
  const components = decodeURI(url).split("?");
  const pathname = components[0].split("#")[0];
  const search = components[1] || "";
  return { pathname, search };
}
function getSearchParamsQs(url, key) {
  const components = getComponents(url);
  const value = deserialize(components.search, key);
  return value;
}
function updateSearchParamsQs(url, value, key) {
  const components = getComponents(url);
  const { search, params } = serialize(components.search, value, key);
  return { pathname: components.pathname, query: search };
}
function pushSearchParamsQs(router, value, key) {
  const { pathname, query } = updateSearchParamsQs(router.asPath, value, key);
  router.push({ pathname, query });
}
function pushSearchParamsQsSilently(router, value, key) {
  const { pathname, query } = updateSearchParamsQs(router.asPath, value, key);
  router.push(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function replaceSearchParamsQs(router, value, key) {
  const { pathname, query } = updateSearchParamsQs(router.asPath, value, key);
  router.replace({ pathname, query });
}
function replaceSearchParamsQsSilently(router, value, key) {
  const { pathname, query } = updateSearchParamsQs(router.asPath, value, key);
  router.replace(pathname, { pathname, query }, { shallow: true, scroll: false });
}
function useSearchParamsQs(key) {
  const router = useRouter4();
  const params = getSearchParamsQs(router.asPath, key);
  const pushParams = useCallback7((params2) => {
    pushSearchParamsQs(router, params2, key);
  }, [key, router]);
  const pushParamsSilently = useCallback7((params2) => {
    pushSearchParamsQsSilently(router, params2, key);
  }, [key, router]);
  const replaceParams = useCallback7((params2) => {
    replaceSearchParamsQs(router, params2, key);
  }, [key, router]);
  const replaceParamsSilently = useCallback7((params2) => {
    replaceSearchParamsQsSilently(router, params2, key);
  }, [key, router]);
  return { params, pushParamsSilently, pushParams, replaceParamsSilently, replaceParams };
}

// src/useSorting/useSorting.ts
import { useEffect as useEffect26, useRef as useRef10, useState as useState23 } from "react";
function useSorting(items_, callback_, sort_) {
  const [sort, setSort] = useState23(sort_);
  const [items, setItems] = useState23(callback_(items_.slice(), sort));
  const isInitialMount = useRef10(true);
  useEffect26(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setSort(sort_);
      setItems(callback_(items_.slice(), sort_));
    }
  }, [items_, sort_]);
  function doSort(sort2) {
    setSort(sort2);
    setItems(callback_(items_.slice(), sort2));
  }
  return { items, sort, setSort: doSort };
}

// src/useSyncedRef/useSyncedRef.ts
import { useMemo as useMemo7, useRef as useRef11 } from "react";
function useSyncedRef(value) {
  const ref = useRef11(value);
  ref.current = value;
  return useMemo7(() => Object.freeze({
    get current() {
      return ref.current;
    }
  }), []);
}

// src/useUnit/useUnit.ts
function useUnit(unit = "kilometer", locale) {
  return useNumber({ style: "unit", unit, minimumFractionDigits: 2, maximumFractionDigits: 2 }, locale);
}

// src/useUnmountEffect/useUnmountEffect.ts
import { useEffect as useEffect27 } from "react";
function useUnmountEffect(effect) {
  const effectRef = useSyncedRef(effect);
  useEffect27(() => () => {
    effectRef.current();
  }, []);
}
export {
  ExtraProvider,
  Filter,
  FilterMode,
  KeyCode,
  KeyMod,
  LabelProvider,
  LabelService,
  LayoutProvider,
  LazyModulesProvider,
  MetaDataProvider,
  PageProvider,
  createElementWithId,
  createGenericContext,
  detectIsBrowser,
  filtersToParams,
  getCurrentPosition,
  getFilteredItems,
  getFilters,
  getMoreItems,
  getOwnerPaddingRight,
  getOwnerScrollbarWidth,
  getPagedItems,
  getPagedItemsLegacy,
  getPaginationInfo,
  getPaginationLegacyInfo,
  getPreferredColorScheme,
  getPreferredReducedMotion,
  getRealSize,
  getSearchParams2 as getSearchParams,
  getSearchParamsEncoded,
  getSearchParamsQs,
  getUID,
  hasGeolocation,
  isElement,
  isPaginationInfo,
  isPaginationLegacyInfo,
  localCollectionDelete,
  localCollectionFetch,
  localCollectionGet,
  localCollectionPatch,
  localCollectionPost,
  localCollectionPut,
  parseLabel,
  parseParams,
  pushSearchParams,
  pushSearchParamsEncoded,
  pushSearchParamsEncodedSilently,
  pushSearchParamsQs,
  pushSearchParamsQsSilently,
  pushSearchParamsSilently,
  replaceSearchParams,
  replaceSearchParamsEncoded,
  replaceSearchParamsEncodedSilently,
  replaceSearchParamsQs,
  replaceSearchParamsQsSilently,
  replaceSearchParamsSilently,
  scrollToRelativeY,
  scrollToSelector,
  scrollToY,
  setFilters,
  updateSearchParams,
  updateSearchParamsEncoded,
  updateSearchParamsQs,
  useApi,
  useApiDelete,
  useApiFetch,
  useApiGet,
  useApiPatch,
  useApiPost,
  useApiPut,
  useAutosizeTextArea,
  useBodyScroll,
  useBreakpoint,
  useClickAnyWhere,
  useClickOut,
  useCollectionApi,
  useCollectionApiDelete,
  useCollectionApiGet,
  useCollectionApiPatch,
  useCollectionApiPost,
  useCollectionApiPut,
  useColorScheme,
  useCurrency,
  useCurrentState,
  useDateTimeFormat,
  useDebounce,
  useDebounceCallback,
  useDebugChangedProps,
  useDomObserver,
  useDrawer,
  useElementSize,
  useEventListener,
  useExtra,
  useFilters,
  useFocusTrap,
  useGeolocation,
  useIdle,
  useInfiniteLoader,
  useIntersectionObserver,
  useIsomorphicLayoutEffect,
  useKeyboard,
  useLabel,
  useLayout,
  useLazyModules,
  useMetaData,
  useModal,
  useMounted,
  useNumber,
  usePage,
  usePageLoading,
  usePagination,
  usePaginationLegacy,
  usePortal,
  usePrevious,
  useRealSize,
  useReducedMotion,
  useReducedMotionLocal,
  useResize,
  useSSR,
  useScroll,
  useScrollTo,
  useScrolled,
  useSearchParams,
  useSearchParamsEncoded,
  useSearchParamsQs,
  useSearchParamsValue,
  useSorting,
  useSyncedRef,
  useUI,
  useUnit,
  useUnmountEffect,
  useWindowSize
};
